// extracted by mini-css-extract-plugin
export default {"container":"Placeholder_container__6+Sbp","placeholderShimmer":"Placeholder_placeholderShimmer__+9Xhz","dark":"Placeholder_dark__wNk-K"};